"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../../container"));

var _navigationGroup = _interopRequireDefault(require("./navigation-group"));

var _navigationGroupItem = _interopRequireDefault(require("./navigation-group-item"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Menu = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Menu, _Component);

  var _super = _createSuper(Menu);

  function Menu() {
    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      activeNavGroup: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setNavigationGroups", function (ref) {
      _this.navigationGroups = ref;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNavGroupClick", function (i) {
      _this.setState(function (state) {
        return {
          activeNavGroup: state.activeNavGroup === i ? null : i
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBackgroundClick", function (e) {
      if (_this.state.activeNavGroup !== null && !_this.navigationGroups.contains(e.target)) {
        _this.setState({
          activeNavGroup: null
        });

        e.preventDefault();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleBackgroundClick);
      window.addEventListener('touchstart', this.handleBackgroundClick, {
        passive: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleBackgroundClick);
      window.removeEventListener('touchstart', this.handleBackgroundClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          navigationMenu = _this$props.navigationMenu,
          createLinkElement = _this$props.createLinkElement,
          children = _this$props.children;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.state.activeNavGroup !== null && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_indexModule.default.background, className)
      }), /*#__PURE__*/_react.default.createElement(_container.default, {
        className: _indexModule.default.container,
        type: "large"
      }, /*#__PURE__*/_react.default.createElement("nav", {
        className: _indexModule.default.navigationGroups,
        ref: this.setNavigationGroups,
        id: "menu",
        "aria-label": "Main navigation"
      }, navigationMenu && navigationMenu.map(function (group, i) {
        return /*#__PURE__*/_react.default.createElement(_navigationGroup.default, {
          key: group.title || group.label,
          title: group.title || group.label,
          className: className,
          isSingleItem: !!group.url,
          isMenuOpen: i === _this2.state.activeNavGroup,
          menuIndex: i,
          handleClick: _this2.handleNavGroupClick
        }, (Array.isArray(group.items) ? group.items : [group]).map(function (item) {
          return /*#__PURE__*/_react.default.createElement(_navigationGroupItem.default, {
            item: item,
            key: item.url,
            createLinkElement: createLinkElement
          });
        }));
      }), children && _react.default.Children.map(children, function (child, i) {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          isMenuOpen: i === _this2.state.activeNavGroup,
          menuIndex: i,
          handleClick: _this2.handleNavGroupClick
        });
      }))));
    }
  }]);
  return Menu;
}(_react.Component);

(0, _defineProperty2.default)(Menu, "propTypes", {
  className: _propTypes.default.string,
  navigationMenu: _propTypes.default.array,
  createLinkElement: _propTypes.default.func,
  children: _propTypes.default.node
});
var _default = Menu;
exports.default = _default;